<template>
  <div>
    <div class="form-container" style="padding: 0">
      <el-form inline size="mini" disabled label-width="120px" :model="conditions">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="品牌(BQ)">
              <el-select v-model="conditions.brand_bq">
                <el-option v-for="item in selectDataOptions['A0018']" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="大类">
              <el-input v-model="conditions.bcate" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="中类">
              <el-input v-model="conditions.mcate" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="预留项3">
              <el-select v-model="conditions.reserved3">
                <el-option value="E0006" label="预留项3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="小类">
              <el-input v-model="conditions.scate" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="预留项4">
              <el-select v-model="conditions.reserved4">
                <el-option value="E0006" label="预留项4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="月报分类">
              <el-select v-model="conditions.ycate">
                <el-option v-for="item in selectDataOptions['A0016']" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="预留项5">
              <el-select v-model="conditions.reserved5">
                <el-option value="E0006" label="预留项5" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="品牌(生产计划)">
              <el-select v-model="conditions.brand">
                <el-option v-for="item in selectDataOptions['A0015']" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否定制">
              <el-select
                v-model="conditions.cmade"
                placeholder="请选择"
              >
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否出口">
              <el-select
                v-model="conditions.isept"
                placeholder="请选择"
              >
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="经营计划新产品分类">
              <el-input v-model="conditions.reserved8_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="编号">
              <el-input v-model="conditions.numbr" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="指挥中心分类">
              <el-input v-model="conditions.reserved9" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'

export default {
  props: {
    prod: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      conditions: {
        brand_bq: '',
        bcate: '',
        mcate: '',
        reserved3: '',
        scate: '',
        reserved4: '',
        ycate: '',
        reserved5: '',
        brand: '',
        cmade: '',
        isept: '',
        reserved8: '',
        numbr: '',
        reserved9: ''
      },
      selectDataOptions: {}
    }
  },
  created() {
    for (const key in this.conditions) {
      this.conditions[key] = this.prod[key]
    }
    this.getSelectDictDataOrigin('A0016')
    this.getSelectDictDataOrigin('A0015')
    this.getSelectDictDataOrigin('A0018')
  },
  methods: {
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/product-manage/components/AttachInfoCheck.vue